import { SetStateAction, useState } from "react";
import { createPortal } from "react-dom";
import { ClearBtn, ConfirmationModal, Footer, Button, Logo } from "..";
import { ContactList } from "src/Containers";
import { ContactType } from "src/Types/ReDoc/Contact";
import { CheckBox } from "../Controls";
import API from "src/API";
import { useLocalStorage } from "src/Hooks";
import './Help.scss';

interface IHelpProps {
	isFull?: boolean;
    version?: string;
    contactList: Array<ContactType>;
	onClose?: () => void;
	showCloseBtn?: boolean;
};

/** Компонента вывода окна помощи */
const Help: React.FC<IHelpProps> = ( { version, isFull = true, contactList, showCloseBtn = false, onClose } ) => {

	const [ isShowLearning, setIsShowLearning ] = useLocalStorage( "isShowLearning", "false" );
	const [ showConfirm, setShowConfirm ] = useState<boolean>(false);

	// const [ ,, toggleTheme ] = useTheme('light');

	const onSetShowLearning = ( value: SetStateAction<boolean> ) => {
		const val = value.valueOf();
		setIsShowLearning( val.toString() );
	};

	const renderControls = () => {
		if ( !isFull ) return null;
		return (
			<div className="controls">
				<CheckBox name="learning" value={ isShowLearning !== "false" } setValue={onSetShowLearning}>
					Включить обучение
				</CheckBox>
				<Button onClick={ () => setShowConfirm(true) }>
					<svg width="18" height="18" viewBox="0 0 18 18" fill="inherit" xmlns="http://www.w3.org/2000/svg">
						<path d="M1.5 9C1.5 12.7275 4.5225 15.75 8.25 15.75C10.0425 15.75 11.76 15.045 13.05 13.8L11.925 12.675C10.9725 13.6875 9.645 14.25 8.25 14.25C3.57 14.25 1.23 8.595 4.5375 5.2875C7.845 1.98 13.5 4.3275 13.5 9H11.25L14.25 12H14.325L17.25 9H15C15 5.2725 11.9775 2.25 8.25 2.25C4.5225 2.25 1.5 5.2725 1.5 9Z" fill="inherit"/>
					</svg>			
					&emsp;	
					Сбросить кэш
				</Button>
				{/* <Button onClick={toggleTheme}>Сменить тему оформления</Button> */}
			</div>
		);
	};

	const confirmModal = (
		<ConfirmationModal
			color="red"
			title="Сброс кэша браузера"
			text="Вы действительно хотите сбросить кэш браузера? "
			onConfirm={ () => API.Cash.reset() }
			onClose={() => setShowConfirm(false)}
		>
			Сбросятся размеры колонок, фильтры, сортировка, для всех реестров, до состояния по умолчанию заданного в конструкторе.
		</ConfirmationModal>
	);

	return (
		<>
			<div className="help_wrapper">
				{ (showCloseBtn && onClose) && <ClearBtn isClose notHint className="help_wrapper__close" onClick={onClose}></ClearBtn> }
				<div className="help_content">

					<div className="help_content__part">
						<header className="login__header">
							<Logo size="lg" />
						</header>
						{ renderControls() }
					</div>
					
					<ContactList list={contactList}/>
					
				</div>
				<Footer version={version} />
			</div>
			{ showConfirm && createPortal( confirmModal, document.body ) }
		</>
	);
};

export default Help;
